import member from './member'
import auth from './public/auth'
// import errors from './public/errors'

// const members = [...member, ...errors]

export default {
  members: member,
  auth
}
